import { SettingsOverviewListItem } from '@models/brands.model';

export const CompanySettingsList: Array<SettingsOverviewListItem> = [
	{
		name: 'CURRENCY_AND_TAXES',
		title: 'Currency & Taxes',
		icon: 'fi-currency-texes',
		url: '/settings/currency_and_taxes',
		description: 'Currency, tax name and rate.'
	},
	{
		name: 'EMAIL_SETTINGS',
		title: 'Email Settings',
		icon: 'fi-email-settings',
		url: '/settings/email_settings',
		description: 'Set up your email server.'
	},
	{
		name: 'CALENDAR',
		title: 'Date, Time & Calendar',
		icon: 'fi-calendar-settings',
		url: '/settings/google_cal',
		description: 'Google Calendar integration, data and time format.',
		dataSection: 'calendarSettings'
	},
	{
		name: 'PAYMENT_METHODS',
		title: 'Payment Methods',
		icon: 'fi-payment-methods',
		url: '/settings/payment_methods',
		description: 'Set up how your invoices are paid.'
	},
	{
		name: 'PAYMENT_SCHEDULE_AND_REMINDERS',
		title: 'Payment Schedules & Reminders',
		icon: 'fi-payment-schedule',
		url: '/settings/payment_schedules',
		description: 'Set up your invoice terms and reminders.'
	},

	{
		name: 'PRODUCTS_AND_PACKAGES',
		title: 'Products & Packages',
		icon: 'fi-products',
		url: '/settings/products_packages',
		description: 'Create product adn packages that you sell.',
		dataSection: 'productsAndPackages'
	},
	{
		name: 'CONTACT_FORM',
		title: 'Contact Form',
		icon: 'fi-form',
		url: '/settings/contact_form',
		description: 'Create and embed contact forms.'
	},
	{
		name: 'WORKFLOWS',
		title: 'Workflows',
		icon: 'fi-workflows',
		url: '/settings/workflows',
		description: 'Create Workflows and automation.'
	},
	{
		name: 'JOB_TYPES',
		title: 'Job Types',
		icon: 'fi-types',
		url: '/settings/job_types',
		description: 'Set up job types and link them to workflows.'
	},
	{
		name: 'EMAIL_TEMPLATES',
		title: 'Email Templates',
		icon: 'fi-paper-plane',
		url: '/settings/email_templates',
		description: 'Customise your email templates.'
	},
	{
		name: 'CONTRACT_TEMPLATES',
		title: 'Contract Templates',
		icon: 'fi-contract-templates',
		url: '/settings/contracts',
		description: 'Customise your contract templates.'
	},
	{
		name: 'QUESTIONNAIRE_TEMPLATES',
		title: 'Questionnaire Templates',
		icon: 'fi-questionnaire-templates',
		url: '/settings/questionnaires',
		description: 'Customise your questionnaire Templates.'
	},
	{
		name: 'INTEGRATIONS',
		title: 'Integrations',
		icon: 'fi-integrate',
		url: '/settings/integrations',
		description: 'Connect with Xero, QuickBooks and more.'
	}
];

export const GlobalSettingsList: Array<SettingsOverviewListItem> = [
	{
		name: 'ACCOUNT_AND_SUBSCRIPTION',
		title: 'Account & Subscription',
		icon: 'fi-account',
		url: '/settings/profile',
		description: 'Login, password and subscription and billing.'
	},
	{
		name: 'COMPANIES',
		title: 'Companies',
		icon: 'fi-company',
		url: '/settings/companies',
		description: 'Add more companies, edit details, and GDPR'
	},
	{
		name: 'USERS',
		title: 'Users',
		icon: 'fi-users',
		url: '/settings/users',
		description: 'Add more users to your account'
	},
	{
		name: 'REFER_A_FRIEND',
		title: 'Refer a Friend',
		icon: 'fi-refer',
		url: '/settings/refer',
		description: 'Referrals and code.'
	}
];



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/services/settings/settings-overview/settings-overview-item-list.ts